import { ULRpcCaller } from '.';
import {
    LoginSuccessResponseStatus,
    SocialLoginConfig,
    SocialSdkConfig,
    SocialLoginResponseStatus,
    ULPath,
    defaultSDKSettingsResponse,
    defaultTransactionDataResponse,
} from '@ul/common';

type Constructor = new (...args: any[]) => {};

// tslint:disable-next-line: function-name
export function WithULRpcCaller<TBase extends Constructor>(Base: TBase) {
    return class BaseULRpcCaller extends Base implements ULRpcCaller {
        /***************************************************
         ***** Mixin for default UL RPC caller methods *****
         ***************************************************/

        public onExit = () => {};

        public onLoginComplete = (isSuccess: boolean) => {};

        public onLoginSuccess = async () => ({
            loginStatus: LoginSuccessResponseStatus.Success,
        });

        public onNotificationPush = (message: string, isSuccess: boolean) => {};

        public onRouteChange = (path: ULPath, isBack: boolean) => {};

        public onSignout = () => {};

        public onSocialLogin = async (config: SocialLoginConfig) => ({
            status: SocialLoginResponseStatus.NotImplemented,
        });

        public onSpaWillLoad = async () => defaultSDKSettingsResponse;

        public onSocialSdkLoad = async (config: SocialSdkConfig) => true;

        public onSpaLoad = (spaLoadCompletedAt: number) => {};

        public onWindowSizeChanged = (height: number, width: number) => {};

        public onDeleteAccountSuccess = () => {};

        public onDeleteAccountExit = () => {};

        public onForceLogoutSuccess = () => {};

        public onForceLogoutExit = () => {};

        public onDismissButtonClick = () => {};

        public onVerifyOtp = (message: string, isSucces: boolean, status: number) => {};

        public onWalletAuthenticated = (success: boolean) => {};

        public onTransactionWillLoad = async () => defaultTransactionDataResponse;
    };
}
